import { useMutation, useQuery } from '@apollo/client';
import { Spin, Typography, notification } from 'antd';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import {
  extractMyOnboardingTasks,
  myOnboardingTasksQuery,
  submitOnboardingTaskResponseMutation,
} from './constants';
import { PartnerGroup } from './MyOnboardingTaskRow';

const { Title } = Typography;

function MyOnboardingTasksWidget() {
  const { data, loading, refetch } = useQuery(myOnboardingTasksQuery, {
    fetchPolicy: 'cache-and-network',
  });
  const tasks = extractMyOnboardingTasks(data);

  const [submitResponse] = useMutation(submitOnboardingTaskResponseMutation);

  const handleSubmit = async (partnerOnboardingId, templateId, answer) => {
    try {
      await submitResponse({
        variables: { input: { _id: partnerOnboardingId, templateId, answer } },
      });
      await refetch();
    } catch (err) {
      notification.error({
        message: 'Error saving task',
        description: err.message,
      });
    }
  };

  const groups = useMemo(() => {
    const map = {};
    tasks.forEach((task) => {
      const key = task.partnerOnboardingId;
      if (!map[key]) {
        map[key] = {
          partnerOnboardingId: task.partnerOnboardingId,
          contactId: task.contactId,
          contactName: task.contactName,
          region: task.region,
          regionName: task.regionName,
          tasks: [],
        };
      }
      map[key].tasks.push(task);
    });
    return Object.values(map);
  }, [tasks]);

  if (loading && !tasks.length) {
    return (
      <div>
        <Title level={2} style={{ margin: '0 0 16px' }}>
          My Onboarding Tasks
        </Title>
        <Spin />
      </div>
    );
  }

  if (!tasks.length) return null;

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          margin: '0 0 16px',
        }}
      >
        <Title level={2} style={{ margin: 0 }}>
          My Onboarding Tasks
        </Title>
        <Link to="/my-onboarding-tasks">View all</Link>
      </div>
      {groups.map((group) => (
        <PartnerGroup
          key={group.partnerOnboardingId}
          {...group}
          onSubmit={handleSubmit}
        />
      ))}
    </div>
  );
}

export default MyOnboardingTasksWidget;
